import { useSprintQuery } from "sprint-common-web";

import { useCloudFileApi } from "../../../../../../common/api/master-api/cloud-files/useCloudFileApi";
import { CloudAssetQueryKey } from "../../../common/CloudAssetQueryKey";
import { mapToProxyItem, ProxyItem } from "./ProxyItem";

export const useCloudAssetProxies = (cloudFileId?: string) => {
    const { getCloudFileProxies } = useCloudFileApi();

    return useSprintQuery<ProxyItem[]>({
        queryKey: [CloudAssetQueryKey.CloudProxies, cloudFileId],
        queryFn: async (): Promise<ProxyItem[]> => {
            if (!cloudFileId) {
                return [];
            }

            const response = await getCloudFileProxies({ cloudFileId });

            return response.proxies.map(mapToProxyItem);
        }
    });
};
